/*
 * Scroll to top of Q and A section after SEOContent loads,
 * then add event listeners to updated pagination buttons
 */
import { QAndAUtils } from '../questions-and-answers-utils';

export const qAndAURL = ({ conversations, bvHost, ugcHost }) => {
  return conversations
    ? `${bvHost}/en_US/bv.js`
    : `${ugcHost}/static/1999aa/bvapi.js`;
};

export const configureBV = ({ itemId }) => {
  window.$BV.configure('global', {
    allowSamePageSubmission: true,
    productId: itemId,
    submissionUI: 'LIGHTBOX',
  });
  window.$BV.ui('qa', 'show_questions', {
    subjectType: 'product',
  });
};
/*
 * Wait for SEOContent to load and then
 * add pagination button listeners for
 * smooth scrolling
 */
export const addPaginationEventListeners = (onClick) => {
  const maxAttempts = 40;
  let iteration = 0;
  const interval = setInterval(() => {
    iteration += 1;
    if (iteration > maxAttempts) {
      clearInterval(interval);
    }
    const bvqaPageLinks = document.getElementsByClassName('BVQAPageLink');
    if (bvqaPageLinks.length > 0) {
      const unselectedLinks = Array.from(bvqaPageLinks).filter((link) => {
        return !link.className.includes('BVQASelectedPageNumber');
      });
      unselectedLinks.forEach((link) => link.getElementsByTagName('a')[0].addEventListener('click', onClick));
      clearInterval(interval);
    }
  }, 250);
};

export const removePaginationEventListeners = (onClick) => {
  const bvqaPageLinks = document.getElementsByClassName('BVQAPageLink');
  if (bvqaPageLinks.length > 0) {
    Array.from(bvqaPageLinks).forEach((link) => {
      if (link.getElementsByTagName('a')[0]) {
        link.getElementsByTagName('a')[0].removeEventListener('click', onClick);
      }
    });
  }
};

export const smoothScroll = ({ channel }) => {
  const bvqaQuestionsId = document.getElementById('BVQAQuestionsID');
  const bvqaQuestionsIdText = bvqaQuestionsId?.innerText;
  if (channel === 'mobile') {
    QAndAUtils.scrollMobile(
      addPaginationEventListeners, smoothScroll, bvqaQuestionsIdText);
  } else {
    QAndAUtils.scrollDesktop(
      addPaginationEventListeners, smoothScroll, bvqaQuestionsIdText);
  }
};

export const addConversationsScript = ({ itemId }) => {
  const content = document.createElement('div');
  content.innerHTML = `
       <div
         data-bv-show="questions"
         data-bv-product-id="${itemId}"
       >
       </div>
       `;

  document.body.appendChild(content);
};

export const loadBV = ({ itemId, url }) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.id = 'BVQAScript';
    script.src = url;
    document.body.appendChild(script);
  }).then(() => {
    configureBV({ itemId });
    addPaginationEventListeners(smoothScroll);
  });
};

export const loadConversations = ({ url }) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.id = 'BVConversations';
    script.src = url;
    document.body.appendChild(script);
  });
};

export const checkOverlayHash = (evt) => {
  const { oldURL = '' } = evt;
  if (oldURL.indexOf('#overlay') > -1) {
    evt.preventDefault();
    // below overlay driven from third party
    if (document.getElementById('BVLBWindow') && document.getElementById('BVLBOverlay')) {
      document.getElementById('BVLBWindow').style.display = 'none';
      document.getElementById('BVLBOverlay').style.display = 'none';
    }
  }
};

export const initializeScriptsAndListeners = ({ conversations, itemId, url }) => {
  if (conversations && document) {
    addConversationsScript({ itemId });
    loadConversations({ url });
  } else {
    if (window) {
      window.addEventListener('hashchange', checkOverlayHash);
    }
    if (window && window.$BV) {
      addPaginationEventListeners(smoothScroll);
      configureBV({ itemId });
    } else {
      loadBV({ itemId, url });
    }
  }
};
